import loadable from "@loadable/component";
import FullPageLoader from "@Components/FullPageLoader";

const TranslationAdmin = loadable(() => import("./TranslationAdmin"), {
  fallback: <FullPageLoader />,
});

export default (props: any): JSX.Element => <TranslationAdmin {...props} />;
